// import DEBUG_TUTORIAL_1 from "./debug-tut-1";
// import DEBUG_TUTORIAL_2 from "./debug-tut-2";
// import DEBUG_TUTORIAL_3 from "./debug-tut-3";
// import PAOLO_TUT_LVL_3 from "./paolo-tut-lvl-3";
import PAOLO_TUT_LVL_4 from "./paolo-tut-lvl-4";
import TEST_TUTORIAL from "./test-tutorial-1";
import TEST_TUTORIAL_2 from "./test-tutorial-2";

// const TUTORIAL_LEVEL_ORDER = [
//   DEBUG_TUTORIAL_1,
//   DEBUG_TUTORIAL_2,
//   DEBUG_TUTORIAL_3,
// ];

const TUTORIAL_LEVEL_ORDER = [
  TEST_TUTORIAL,
  TEST_TUTORIAL_2,
  // PAOLO_TUT_LVL_3,
  PAOLO_TUT_LVL_4,
];

export default TUTORIAL_LEVEL_ORDER;
